import History from '../../utils/history';

export default {
  name: 'history',
  static: {
    history: History,
  },
  on: {
    init() {
      History.init(this);
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/framework7/dist/modules/history/history.js